var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100",attrs:{"id":"list"}},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.orders,"search-options":{
      enabled: true,
      trigger: 'enter',
      skipDiacritics: true,        
    }},on:{"on-row-click":_vm.openWindow}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }